export const DEFAULT_NUTRITION_ROWS = [
  { label: "Energy", value: "{{nutrition.energy}}" },
  { label: "Protein", value: "{{nutrition.protein}}" },
  { label: "Fat", value: "{{nutrition.fat}}" },
  { label: "Carbohydrates", value: "{{nutrition.carbohydrates}}" },
  { label: "Sugar", value: "{{nutrition.sugar}}" },
  { label: "Fibre", value: "{{nutrition.fibre}}" },
  { label: "Sodium", value: "{{nutrition.sodium}}" },
  { label: "Iron", value: "{{nutrition.iron}}" },
  { label: "Calcium", value: "{{nutrition.calcium}}" },
];

export const createDefaultNutritionRows = () =>
  DEFAULT_NUTRITION_ROWS.map((row, index) => ({
    id: `nutrition-row-${index + 1}`,
    ...row,
  }));

export const normalizeNutritionRows = (rows) => {
  const fallbackRows = createDefaultNutritionRows();
  const sourceRows = Array.isArray(rows) && rows.length ? rows : fallbackRows;

  return sourceRows.map((row, index) => ({
    id:
      typeof row?.id === "string" && row.id.trim()
        ? row.id
        : `nutrition-row-${index + 1}`,
    label:
      typeof row?.label === "string" && row.label.trim()
        ? row.label
        : fallbackRows[index]?.label || `Row ${index + 1}`,
    value:
      typeof row?.value === "string" && row.value.trim()
        ? row.value
        : fallbackRows[index]?.value || "-",
  }));
};
